(function() {
  'use strict';

  /* ---- Sticky CTA Bar ---- */
  function initStickyBar() {
    var mobileBar = document.querySelector('.r7b__sticky-bar--mobile');
    var desktopBar = document.querySelector('.r7b__sticky-bar--desktop');
    if (!mobileBar && !desktopBar) return;

    var productSection = document.getElementById('product-section');
    var productVisible = false;
    var scrolledPast = false;

    if (productSection) {
      var productObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          productVisible = entry.isIntersecting;
          updateStickyVisibility();
        });
      }, { threshold: 0.1 });
      productObserver.observe(productSection);
    }

    function updateStickyVisibility() {
      var shouldShow = scrolledPast && !productVisible;
      if (mobileBar) {
        mobileBar.classList.toggle('is-visible', shouldShow);
      }
      if (desktopBar) {
        desktopBar.classList.toggle('is-visible', shouldShow);
      }
    }

    window.addEventListener('scroll', function() {
      scrolledPast = window.scrollY > 50;
      updateStickyVisibility();
    }, { passive: true });
  }

  /* ---- Stats Counter Animation ---- */
  function initStatsCounter() {
    var statValues = document.querySelectorAll('.r7b__stat-value');
    if (!statValues.length) return;

    var animated = false;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !animated) {
          animated = true;
          animateCounters();
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });

    var statsSection = document.querySelector('.r7b__stats');
    if (statsSection) {
      observer.observe(statsSection);
    }

    function animateCounters() {
      statValues.forEach(function(el) {
        var target = parseInt(el.getAttribute('data-value'), 10);
        var duration = 1600;
        var startTime = null;

        function easeOut(t) {
          return 1 - Math.pow(1 - t, 3);
        }

        function step(timestamp) {
          if (!startTime) startTime = timestamp;
          var elapsed = timestamp - startTime;
          var progress = Math.min(elapsed / duration, 1);
          var easedProgress = easeOut(progress);
          var current = Math.round(easedProgress * target);
          el.textContent = current + '%';

          if (progress < 1) {
            requestAnimationFrame(step);
          }
        }

        requestAnimationFrame(step);
      });
    }
  }

  /* ---- Embla Carousel ---- */
  function initCarousel() {
    var viewportNode = document.querySelector('.r7b__embla-viewport');
    if (!viewportNode) return;

    var EmblaCarousel = window.EmblaCarousel;
    if (!EmblaCarousel) return;

    var embla = EmblaCarousel(viewportNode, {
      align: 'center',
      containScroll: 'trimSnaps',
      loop: true,
      dragFree: false
    });

    var prevBtn = document.querySelector('.r7b__embla-btn--prev');
    var nextBtn = document.querySelector('.r7b__embla-btn--next');
    var dotsContainer = document.querySelector('.r7b__embla-dots');

    if (prevBtn) {
      prevBtn.addEventListener('click', function() { embla.scrollPrev(); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() { embla.scrollNext(); });
    }

    function updateDots() {
      if (!dotsContainer) return;
      var selected = embla.selectedScrollSnap();
      var dots = dotsContainer.querySelectorAll('.r7b__embla-dot');
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === selected);
      });
    }

    function createDots() {
      if (!dotsContainer) return;
      var snaps = embla.scrollSnapList();
      dotsContainer.innerHTML = '';
      snaps.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.className = 'r7b__embla-dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function() { embla.scrollTo(i); });
        dotsContainer.appendChild(dot);
      });
      updateDots();
    }

    embla.on('select', updateDots);
    embla.on('init', createDots);
    embla.on('pointerDown', function() {
      document.querySelectorAll('[data-video-card] video').forEach(function(v) {
        if (!v.paused) { v.pause(); }
      });
    });
  }

  /* ---- Review Cards Embla Carousel ---- */
  function initReviewCarousel() {
    var viewportNode = document.querySelector('.r7b__review-embla-viewport');
    if (!viewportNode) return;

    var EmblaCarousel = window.EmblaCarousel;
    if (!EmblaCarousel) return;

    var embla = EmblaCarousel(viewportNode, {
      align: 'start',
      containScroll: 'trimSnaps',
      loop: true,
      dragFree: false
    });

    var dotsContainer = document.querySelector('.r7b__review-embla-dots');

    function updateDots() {
      if (!dotsContainer) return;
      var selected = embla.selectedScrollSnap();
      var dots = dotsContainer.querySelectorAll('.r7b__review-embla-dot');
      dots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === selected);
      });
    }

    function createDots() {
      if (!dotsContainer) return;
      var snaps = embla.scrollSnapList();
      dotsContainer.innerHTML = '';
      snaps.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.className = 'r7b__review-embla-dot';
        dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
        dot.addEventListener('click', function() { embla.scrollTo(i); });
        dotsContainer.appendChild(dot);
      });
      updateDots();
    }

    embla.on('select', updateDots);
    embla.on('init', createDots);
  }

  /* ---- Video Cards ---- */
  function initVideoCards() {
    var videoCards = document.querySelectorAll('[data-video-card]');
    if (!videoCards.length) return;

    videoCards.forEach(function(card) {
      var video = card.querySelector('video');
      var playBtn = card.querySelector('.r7b__video-play-btn');
      if (!video || !playBtn) return;

      playBtn.addEventListener('click', function() {
        video.play();
        video.controls = true;
        playBtn.classList.add('is-hidden');
      });

      video.addEventListener('pause', function() {
        playBtn.classList.remove('is-hidden');
        video.controls = false;
      });

      video.addEventListener('ended', function() {
        playBtn.classList.remove('is-hidden');
        video.controls = false;
      });
    });
  }

  /* ---- Smooth Scroll ---- */
  function initSmoothScroll() {
    var ctaLinks = document.querySelectorAll('a[href="#product-section"]');
    ctaLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var target = document.getElementById('product-section');
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  }

  /* ---- Hide Nav, Footer & PDP Sticky ATC ---- */
  function hideNavAndFooter() {
    var selectors = [
      '#shopify-section-header',
      '#shopify-section-footer',
      '#shopify-section-announcement-bar',
      'header.header',
      'footer.footer',
      '.section-header',
      '.section-footer'
    ];
    selectors.forEach(function(sel) {
      var el = document.querySelector(sel);
      if (el) el.style.display = 'none';
    });

    // Hide PDP hero sticky ATC bars
    var pdpStickyBars = document.querySelectorAll('.reformly-pdp__sticky-bar');
    pdpStickyBars.forEach(function(bar) {
      bar.style.display = 'none';
    });
  }

  /* ---- Init ---- */
  function init() {
    hideNavAndFooter();
    initStickyBar();
    initStatsCounter();
    initCarousel();
    initReviewCarousel();
    initVideoCards();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
